import { h } from "preact";
import { UseFormRegister } from "react-hook-form";
import { IFormInputs } from "./index";

interface IFormProps {
  register: UseFormRegister<IFormInputs>;
  optionsSum: number;
  productsSum: number;
  setupSum: number;
  handleSubmit: () => void;
}

function Form({
  register,
  optionsSum,
  productsSum,
  setupSum,
  handleSubmit,
}: IFormProps) {
  return (
    <div className="single-serviceConsole__kits__wrapper-form-block-body-right">
      <div className="single-serviceConsole__kits__wrapper-form-block-body-right-content">
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-content-item">
          <span>Абонентская плата</span>
          <p>{"от " + optionsSum + " руб./месяц"}</p>
        </div>
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-content-item">
          <span>Стоимость оборудования</span>
          <p>{"от " + productsSum + " руб."}</p>
        </div>
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-content-item">
          <span>Монтажные работы</span>

          <p>
            {setupSum > 0
              ? "от " + setupSum + " руб."
              : "Монтажные работы в подарок"}
          </p>
        </div>
      </div>
      <form
        className="single-serviceConsole__kits__wrapper-form-block-body-right-bottom"
        onSubmit={handleSubmit}
      >
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-input">
          <input
            type="text"
            required
            name="name"
            placeholder="Введите имя"
            {...register("name", {
              required: true,
              maxLength: 50,
            })}
          />
        </div>
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-input">
          <input
            type="tel"
            required
            name="phone"
            placeholder="Введите телефон"
            {...register("phone", {
              required: true,
            })}
          />
        </div>
        <div className="single-serviceConsole__kits__wrapper-form-block-body-right-button">
          <button type="submit">Оставить заявку</button>
        </div>
       
          <span className="text-sm mt-3 ">
            Этот сайт защищен reCAPTCHA и Google.
            <br/>
            Применяются <a href="https://policies.google.com/privacy">Политика конфиденциальности</a> и{" "}
            <a href="https://policies.google.com/terms">Условия обслуживания</a>.
          </span>
      </form>
    </div>
  );
}

export { Form };
